(function MytripsTestimonials($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/MyTrips/testimonials/', function onload()
		{
			$(".comment").shorten({
				showChars: 200,
				moreText : "See More",
				lessText : "Less",
			});
		});
	});
}(jQuery, window.Adzuki || {}));
